import apiClient from '@/services/rest-api-vsms/apiClient'

const baseEndpoint = '/freshchat-user'

export const get = async (userId) => {
  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}/${userId}`,
  })
  return response?.data
}

export const store = async (data) => {
  const response = await apiClient({
    method: 'POST',
    url: baseEndpoint,
    data,
  })

  return response?.data
}